import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useGetGroupNameHelperText = (
    groupName: string,
    existingGroupsNames: string[],
): string => {
    const { t } = useTranslation();
    return useMemo(() => {
        if (groupName.length === 0)
            return t('adminSpace.createUserGroup.missingName');
        if (existingGroupsNames.includes(groupName))
            return t('adminSpace.createUserGroup.nameAlreadyExists');
        return '';
    }, [existingGroupsNames, groupName]);
};
